<template>
  <header id="page-header">
    <div
      v-if="title || $slots.title || $slots.extra"
      class="content content-header py-3"
    >
      <h3 class="my-0">
        <b-button
          class="pl-0 font-w700 font-size-lg d-md-none"
          variant="link"
          @click="$store.commit('setSidebarCollapsed', !$store.state.layout.sidebarCollapsed)"
        >
          <i class="fa fa-bars" />
        </b-button>
      </h3>
      <h3
        v-if="showBackButton"
        class="my-0"
      >
        <b-button
          @click="() => $router.go(-1)"
          class="pl-0 font-w700 font-size-lg d-md-block d-none"
          variant="link"
        >
          <i class="fa fa-arrow-left" />
        </b-button>
      </h3>
      <div
        v-if="title || $slots.title"
        class="d-lg-flex flex-grow-1 align-items-center mr-lg-2"
      >
        <div class="flex-column">
          <h1
            v-if="title"
            class="flex-sm-fill h3 my-0 text-dark font-w600"
          >
            {{ title }}
          </h1>
          <p
            v-if="subtitle"
            class="flex-sm-fill my-0 font-w500"
          >
            {{ subtitle }}
          </p>
        </div>
        <slot name="title" />
        <div
          v-if="$slots['secondary-title']"
          class="ml-lg-3 d-flex align-items-center"
        >
          <slot name="secondary-title" />
        </div>
      </div>
      <div
        v-if="$slots.extra"
        class="d-flex flex-wrap align-items-center justify-content-end gap-2 flex-lg-shrink-0"
      >
        <slot name="extra" />
      </div>
    </div>
    <div
      v-if="$slots.banner"
      class="alert-secondary"
    >
      <div
        class="content py-2"
      >
        <slot name="banner" />
      </div>
    </div>
  </header>
</template>

<script>

export default {
  name: 'BasePageHeading',
  props: {
    title: {
      type: String,
      description: 'The title of page heading section',
    },
    subtitle: {
      type: String,
      description: 'The subtitle of page heading section',
    },
    showBackButton: {
      type: Boolean,
      description: 'Whether or not to show a back button before the page title',
      default: false,
    },
  },
};
</script>
